import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';



function Result(props){
    let facebook = 'https://www.facebook.com/sharer/sharer.php?u='
    let link = facebook.concat(props.save)
    return (
        <div style={{padding:"30px",marginTop:"31px"}}>
        <a href={props.save} download="download" className='btn btn-primary mt-3 mb-3 '>Save</a>
        <a href={link} target="_blank" className='btn btn-primary ml-3 mt-3 mb-3 '>
        Share On <FacebookIcon/>
        </a>
       
        <div className='imagecontainer'>
            <img src={props.url} className="img-fluid image"/>
        </div>
 
    </div>
        
    )
}

export default Result